// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Dldi","col":"styles_col__2EjGM"};